import React from 'react';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';

const PersonalDetailsForm = ({ formData, errors, onChange }) => {
  const genderOptions = [
    { value: 'male', label: 'Male' },
    { value: 'female', label: 'Female' },
    { value: 'other', label: 'Other' },
    { value: 'prefer-not-to-say', label: 'Prefer not to say' }
  ];

  const stateOptions = [
    { value: 'maharashtra', label: 'Maharashtra' },
    { value: 'karnataka', label: 'Karnataka' },
    { value: 'delhi', label: 'Delhi' },
    { value: 'tamil-nadu', label: 'Tamil Nadu' },
    { value: 'gujarat', label: 'Gujarat' },
    { value: 'rajasthan', label: 'Rajasthan' },
    { value: 'west-bengal', label: 'West Bengal' },
    { value: 'telangana', label: 'Telangana' }
  ];

  const careerPreferenceOptions = [
    { value: 'full-time', label: 'Full-time Employment' },
    { value: 'internship', label: 'Internship' },
    { value: 'part-time', label: 'Part-time' },
    { value: 'freelance', label: 'Freelance' },
    { value: 'contract', label: 'Contract' }
  ];

  return (
    <div className="space-y-6">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
        <Input
          label="Full Name"
          type="text"
          placeholder="Enter your full name"
          value={formData?.fullName}
          onChange={(e) => onChange('fullName', e?.target?.value)}
          error={errors?.fullName}
          required
        />
        <Input
          label="Date of Birth"
          type="date"
          value={formData?.dateOfBirth}
          onChange={(e) => onChange('dateOfBirth', e?.target?.value)}
          error={errors?.dateOfBirth}
          required
        />
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
        <Select
          label="Gender"
          options={genderOptions}
          value={formData?.gender}
          onChange={(value) => onChange('gender', value)}
          error={errors?.gender}
          required
        />
        <Input
          label="Email Address"
          type="email"
          placeholder="your.email@example.com"
          value={formData?.email}
          onChange={(e) => onChange('email', e?.target?.value)}
          error={errors?.email}
          required
        />
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
        <Input
          label="Phone Number"
          type="tel"
          placeholder="+91 98765 43210"
          value={formData?.phone}
          onChange={(e) => onChange('phone', e?.target?.value)}
          error={errors?.phone}
          required
        />
        <Input
          label="Alternate Phone"
          type="tel"
          placeholder="+91 98765 43210"
          value={formData?.alternatePhone}
          onChange={(e) => onChange('alternatePhone', e?.target?.value)}
        />
      </div>
      <Input
        label="Current Address"
        type="text"
        placeholder="Enter your complete address"
        value={formData?.address}
        onChange={(e) => onChange('address', e?.target?.value)}
        error={errors?.address}
        required
      />
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6">
        <Input
          label="City"
          type="text"
          placeholder="Mumbai"
          value={formData?.city}
          onChange={(e) => onChange('city', e?.target?.value)}
          error={errors?.city}
          required
        />
        <Select
          label="State"
          options={stateOptions}
          value={formData?.state}
          onChange={(value) => onChange('state', value)}
          error={errors?.state}
          required
        />
        <Input
          label="PIN Code"
          type="text"
          placeholder="400001"
          value={formData?.pincode}
          onChange={(e) => onChange('pincode', e?.target?.value)}
          error={errors?.pincode}
          required
        />
      </div>
      <Select
        label="Career Preference"
        description="Select your preferred employment type"
        options={careerPreferenceOptions}
        value={formData?.careerPreference}
        onChange={(value) => onChange('careerPreference', value)}
        multiple
        searchable
        error={errors?.careerPreference}
        required
      />
      <Input
        label="LinkedIn Profile"
        type="url"
        placeholder="https://linkedin.com/in/yourprofile"
        value={formData?.linkedin}
        onChange={(e) => onChange('linkedin', e?.target?.value)}
      />
      <Input
        label="Portfolio Website"
        type="url"
        placeholder="https://yourportfolio.com"
        value={formData?.portfolio}
        onChange={(e) => onChange('portfolio', e?.target?.value)}
      />
    </div>
  );
};

export default PersonalDetailsForm;